import React from 'react';
import PropTypes from 'prop-types';
import { useClassName } from 'common/hooks';
import { ContentfulRichText } from 'common/components';
import './venue-details-hero-subtitle.less';

const VenueDetailsHeroSubtitle = ({ text }) => {
  const className = useClassName('VenueDetailsHeroSubtitle');

  return (
    <div className={className('container')}>
      <ContentfulRichText className={className('text')} field={text} />
    </div>
  );
};

VenueDetailsHeroSubtitle.propTypes = {
  text: PropTypes.object.isRequired,
};

export default VenueDetailsHeroSubtitle;
